export default __webpack_public_path__ + "static/media/stock.280f8c65.png";